import { AxiosError } from "axios";
declare const ocm: { config: { CSRFToken: string } };

export const getCSRFToken = (): string => ocm?.config?.CSRFToken;

export const setCSRFToken = (token: string): void => {
	ocm.config.CSRFToken = token;
};

export const csrfHandler = (failedRequest: AxiosError): Promise<void> => {
	const token = failedRequest?.response?.headers["csrftoken"];
	token && setCSRFToken(token);
	if (failedRequest.response?.config.headers && token) {
		failedRequest.response.config.headers["CSRFToken"] = token;
	}
	return Promise.resolve();
};
